export default __webpack_public_path__ + "static/media/MenuIcon.e607771f.svg";